import { render, staticRenderFns } from "./customerInput.vue?vue&type=template&id=589be364&scoped=true&"
import script from "./customerInput.vue?vue&type=script&lang=js&"
export * from "./customerInput.vue?vue&type=script&lang=js&"
import style0 from "./customerInput.vue?vue&type=style&index=0&id=589be364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589be364",
  null
  
)

export default component.exports